import t,{useEffect as q,useState as g}from"react";import{forwardRef as B,createElement as M}from"react";var I=e=>e.replace(/([a-z0-9])([A-Z])/g,"$1-$2").toLowerCase(),P=e=>e.replace(/^([A-Z])|[\s-_]+(\w)/g,(a,o,d)=>d?d.toUpperCase():o.toLowerCase()),L=e=>{let a=P(e);return a.charAt(0).toUpperCase()+a.slice(1)},p=(...e)=>e.filter((a,o,d)=>!!a&&a.trim()!==""&&d.indexOf(a)===o).join(" ").trim(),x=e=>{for(let a in e)if(a.startsWith("aria-")||a==="role"||a==="title")return!0};import{forwardRef as A,createElement as S}from"react";var C={xmlns:"http://www.w3.org/2000/svg",width:24,height:24,viewBox:"0 0 24 24",fill:"none",stroke:"currentColor",strokeWidth:2,strokeLinecap:"round",strokeLinejoin:"round"};var h=A(({color:e="currentColor",size:a=24,strokeWidth:o=2,absoluteStrokeWidth:d,className:s="",children:l,iconNode:i,...m},u)=>S("svg",{ref:u,...C,width:a,height:a,stroke:e,strokeWidth:d?Number(o)*24/Number(a):o,className:p("lucide",s),...!l&&!x(m)&&{"aria-hidden":"true"},...m},[...i.map(([w,k])=>S(w,k)),...Array.isArray(l)?l:[l]]));var f=(e,a)=>{let o=B(({className:d,...s},l)=>M(h,{ref:l,iconNode:a,className:p(`lucide-${I(L(e))}`,`lucide-${e}`,d),...s}));return o.displayName=L(e),o};var F=[["path",{d:"M4 12h16",key:"1lakjw"}],["path",{d:"M4 18h16",key:"19g7jn"}],["path",{d:"M4 6h16",key:"1o0s65"}]],c=f("menu",F);var D=[["path",{d:"M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z",key:"1ffxy3"}],["path",{d:"m21.854 2.147-10.94 10.939",key:"12cjpa"}]],r=f("send",D);var R=[["path",{d:"M18 6 6 18",key:"1bl5f8"}],["path",{d:"m6 6 12 12",key:"d8bk6v"}]],n=f("x",R);var T=({links:e=[{label:"About",href:"https://taylorsams.design/aboutme"},{label:"Work",href:"#work"}],contactEmail:a="taylorjsams@gmail.com",brand:o="Taylor Sams"})=>{let[d,s]=g(!1),[l,i]=g(!1);return q(()=>{let u=()=>{s(window.scrollY>20)};return window.addEventListener("scroll",u),()=>window.removeEventListener("scroll",u)},[]),t.createElement(t.Fragment,null,t.createElement("nav",{className:`
    fixed z-50 transition-all duration-500 ease-in-out
    flex items-center justify-between
    ${d?"top-4 left-4 right-4 md:left-1/2 md:right-auto md:-translate-x-1/2 md:w-[90%] max-w-5xl rounded-full bg-black/70 backdrop-blur-md border border-white/10 py-3 px-6 shadow-lg":"top-0 left-0 right-0 w-full bg-black py-5 px-6 md:px-12 border-b border-white/5"}
  `},t.createElement("div",{className:"flex-shrink-0"},t.createElement("a",{href:"https://taylorsams.design/",className:"text-white font-bold text-xl tracking-tight hover:text-gray-200 transition-colors"},o)),t.createElement("div",{className:"hidden md:flex items-center gap-8"},t.createElement("div",{className:"flex items-center gap-8"},e.map(u=>t.createElement("a",{key:u.label,href:u.href,className:"text-sm font-medium text-gray-300 hover:text-white transition-colors"},u.label))),t.createElement("a",{href:`mailto:${a}`,className:`
              flex items-center gap-2 px-5 py-2 rounded-full font-medium text-sm transition-all duration-300
              ${d?"bg-white text-black hover:bg-gray-200":"bg-white/10 text-white hover:bg-white/20 border border-white/10"}
            `},t.createElement("span",null,"Contact Me"),t.createElement(r,{size:14}))),t.createElement("button",{className:"md:hidden text-white p-1",onClick:()=>i(!l),"aria-label":"Toggle menu"},l?t.createElement(n,{size:24}):t.createElement(c,{size:24}))),t.createElement("div",{className:`
          fixed inset-0 z-40 bg-black/95 backdrop-blur-xl transition-all duration-300 md:hidden flex flex-col justify-center items-center gap-8
          ${l?"opacity-100 pointer-events-auto":"opacity-0 pointer-events-none"}
        `},e.map(u=>t.createElement("a",{key:u.label,href:u.href,className:"text-2xl font-medium text-white hover:text-gray-300",onClick:()=>i(!1)},u.label)),t.createElement("a",{href:`mailto:${a}`,className:"mt-4 flex items-center gap-2 px-8 py-3 bg-white text-black rounded-full font-bold text-lg hover:bg-gray-200 transition-colors",onClick:()=>i(!1)},"Contact Me ",t.createElement(r,{size:18}))))};export{T as Navbar};
/*! Bundled license information:

lucide-react/dist/esm/shared/src/utils.js:
  (**
   * @license lucide-react v0.522.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/defaultAttributes.js:
  (**
   * @license lucide-react v0.522.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/Icon.js:
  (**
   * @license lucide-react v0.522.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/createLucideIcon.js:
  (**
   * @license lucide-react v0.522.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/icons/menu.js:
  (**
   * @license lucide-react v0.522.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/icons/send.js:
  (**
   * @license lucide-react v0.522.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/icons/x.js:
  (**
   * @license lucide-react v0.522.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/lucide-react.js:
  (**
   * @license lucide-react v0.522.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)
*/
//# sourceMappingURL=index.js.map
